import { ElementRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
const _c0 = ["*"];
export let UiToolbarComponent = /*#__PURE__*/(() => {
  class UiToolbarComponent {
    constructor(el) {
      this.el = el;
    }
    getBlockableElement() {
      return this.el.nativeElement.children[0];
    }
    static {
      this.ɵfac = function UiToolbarComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || UiToolbarComponent)(i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: UiToolbarComponent,
        selectors: [["ui-toolbar"]],
        inputs: {
          style: "style",
          styleClass: "styleClass"
        },
        ngContentSelectors: _c0,
        decls: 2,
        vars: 4,
        consts: [["role", "toolbar", 3, "ngClass", "ngStyle"]],
        template: function UiToolbarComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵprojection(1);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵclassMap(ctx.styleClass);
            i0.ɵɵproperty("ngClass", "ui-toolbar p-component ")("ngStyle", ctx.style);
          }
        },
        dependencies: [CommonModule, i1.NgClass, i1.NgStyle],
        styles: ["@layer primeng{.p-toolbar[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:space-between;flex-wrap:wrap}.p-toolbar-group-start[_ngcontent-%COMP%], .p-toolbar-group-center[_ngcontent-%COMP%], .p-toolbar-group-end[_ngcontent-%COMP%], .p-toolbar-group-left[_ngcontent-%COMP%], .p-toolbar-group-right[_ngcontent-%COMP%]{display:flex;align-items:center}}.ui-toolbar[_ngcontent-%COMP%]{background-color:var(--toolbarBgColor);border:var(--basicPanelBorder);border-radius:4px;border-bottom-left-radius:0!important;border-bottom-right-radius:0!important;border-color:var(--toolbarBorderColor);padding:.5em;display:flex;flex-wrap:wrap;justify-content:space-between;align-items:center}.ui-toolbar[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{vertical-align:middle}.ui-toolbar[_ngcontent-%COMP%]   .ui-toolbar-separator[_ngcontent-%COMP%]{vertical-align:middle;font-size:3em}.ui-toolbar[_ngcontent-%COMP%] >   .center, .ui-toolbar[_ngcontent-%COMP%] >   .ui-toolbar-group-center{display:flex;justify-content:center;flex:1}.ui-toolbar[_ngcontent-%COMP%] >   .right, .ui-toolbar[_ngcontent-%COMP%] >   .ui-toolbar-group-right{display:flex;justify-content:flex-end}"],
        changeDetection: 0
      });
    }
  }
  return UiToolbarComponent;
})();